export default class Person {
    constructor() {
        this.firstName = null;
        this.surname = null;    // also Company Name
        this.isContact = false;
    }
}